module.exports = __webpack_public_path__ + "img/Logo_Glimpse_128x128.13bae621.png";